import i18n from '@/i18n'
import countries from '@/assets/tax-country.json'

const regions = {}
const countryCodes = Object.fromEntries(countries.map(country => [country.name.toLowerCase(), country.code]))

// Translate display labels only. Country codes and submitted form values stay unchanged.
export function countryName (code, fallback = code) {
  const locale = i18n.locale
  const region = /^[a-z]{2}$/i.test(code || '') ? code.toUpperCase() : countryCodes[String(fallback || '').toLowerCase()]
  if (!region || typeof Intl.DisplayNames !== 'function') return fallback
  if (!regions[locale]) regions[locale] = new Intl.DisplayNames([locale === 'zh' ? 'zh-CN' : 'en-NZ'], { type: 'region' })
  try { return regions[locale].of(region) || fallback } catch (_) { return fallback }
}

export function accountTypeName (value) {
  const keys = { I: 'individual', E: 'entity', R: 'referrer', individual: 'individual', personal: 'individual', company: 'company', entity: 'entity', Individual: 'individual', Entity: 'entity' }
  return keys[value] ? i18n.t(`account.${keys[value]}`) : value
}

export function transactionStatusName (value) {
  const key = String(value || '').toLowerCase().replace(/ /g, '_')
  const keys = {
    pending: 'pending',
    processing: 'processing',
    cancelled: 'cancelled',
    canceled: 'cancelled',
    failed: 'failed',
    rejected: 'rejected',
    paid: 'paid',
    completed: 'completed',
    awaiting_payment: 'awaitingPayment',
    released: 'released',
    ready_to_send: 'readyToSend',
    sent: 'sent',
    funds_sent: 'fundsSent',
    funds_arrived: 'fundsArrived',
    deleted: 'deleted'
  }
  return keys[key] ? i18n.t(`accountFlow.${keys[key]}`) : String(value || '').replace(/_/g, ' ')
}
